if (!customElements.get("banner-logo")) {
  class BannerLogo extends HTMLElement {
    constructor() {
      super();

      this.logoWrapper = this.querySelector(".banner-logo__logo-inner");
      this.logo        = this.querySelector(".banner-logo__logo");
      this.header      = document.querySelector(".site-header");

      this.classes = {
        scaling: "header-logo-scaling",
      };
      this.initialized = false;
    }

    connectedCallback() {
      if (!this.logoWrapper) {
        return;
      }

      this.init();
      window.addEventListener("resize", debounce(this.init.bind(this), 100));
      window.addEventListener("scroll", () => {
        window.requestAnimationFrame(() => this.scrollAnimation());
      });
    }

    /* ── Helpers ─────────────────────────────────────────────── */

    /**
     * Read the --logo-max-width / --logo-max-width-mobile CSS custom
     * property that the Liquid template sets inline on <banner-logo>.
     * Falls back to 354 px (desktop) / 220 px (mobile) if not present.
     */
    getLogoMaxWidth() {
      const computedStyle = window.getComputedStyle(this);
      const isMobile      = window.FoxThemeSettings
        ? window.FoxThemeSettings.isMobile
        : window.innerWidth < 768;

      const prop    = isMobile ? "--logo-max-width-mobile" : "--logo-max-width";
      const fallback = isMobile ? 220 : 354;
      const raw     = computedStyle.getPropertyValue(prop).trim();

      return raw ? parseInt(raw, 10) || fallback : fallback;
    }

    /**
     * Calculate the scale factor that would make the logo fill a
     * certain portion of the viewport (the original "big" animation),
     * then cap it so the *rendered* pixel width never exceeds the
     * max-width set in the theme editor.
     *
     * Because CSS max-width limits the element's layout width, scale()
     * still blows past it visually — so we cap the scale value here
     * instead of relying purely on CSS.
     */
    calculateMaxScale() {
      const headerEl      = document.querySelector(".site-header");
      const computedStyle = window.getComputedStyle(headerEl);
      const isMobile      = window.FoxThemeSettings
        ? window.FoxThemeSettings.isMobile
        : window.innerWidth < 768;

      /* Original ratio logic (unchanged from theme default) */
      let logoWidth = computedStyle.getPropertyValue(
        isMobile ? "--logo-mobile-width" : "--logo-width"
      );
      const ratio = isMobile ? 0.83 : 0.58;
      logoWidth    = parseInt(logoWidth.trim(), 10);

      const uncappedScale = (document.body.clientWidth / logoWidth) * ratio;

      /* Cap: determine what scale value corresponds to the max-width
         setting.  The logo's natural (scale-1) width is logoWidth px,
         so to render at maxWidthPx we need scale = maxWidthPx / logoWidth. */
      const maxWidthPx  = this.getLogoMaxWidth();
      const cappedScale = maxWidthPx / logoWidth;

      return Math.min(uncappedScale, cappedScale);
    }

    /* ── Lifecycle ───────────────────────────────────────────── */

    init() {
      this.maxScale = this.calculateMaxScale();
      this.scrollAnimation();

      if (!this.initialized) {
        this.logoWrapper.classList.remove("invisible");
        typeof this.logoWrapper.refreshAnimation === "function" &&
          this.logoWrapper.refreshAnimation();
        this.initialized = true;
      }
    }

    scrollAnimation() {
      const scrollTop    = window.scrollY;
      const scrollTarget = this.offsetTop + this.logoWrapper.offsetTop + 130;
      const scaleRatio   = scrollTop / scrollTarget;
      const scaleValue   = Math.max(
        1,
        this.maxScale - scaleRatio * this.maxScale
      );

      if (this.logo) {
        this.logo.style.transform = `scale(${scaleValue})`;
      }

      if (scaleValue <= 1) {
        this.header.headerSection.classList.remove(this.classes.scaling);
        this.logo.style.setProperty("opacity", 0);
      } else {
        this.header.headerSection.classList.add(this.classes.scaling);
        this.logo.style.setProperty("opacity", 1);
      }
    }
  }

  customElements.define("banner-logo", BannerLogo);
}
